import { Banner } from '@/components/Banner/Banner';
import { RichText } from '@/components/RichText/RichText';
import type { Bundle } from '@/components/Store.d';
import { languageStrings } from '@/l18n/de';
import { getPurUrl } from '@/lib/banner';

type Props = {
	bundle: Bundle | null;
};

const BannerNotQualified = ({ bundle }: Props) => {
	const ctaUrl = getPurUrl(bundle);

	return (
		<Banner className="banner-warning">
			<div className="banner--active-hint">
				<strong>{languageStrings.notQualifiedForCheaperPur.heading}</strong>
				<span>
					<RichText
						components={{ link: <a href={ctaUrl} /> }}
						message={languageStrings.notQualifiedForCheaperPur.explanation}
					/>
				</span>
			</div>
		</Banner>
	);
};

export { BannerNotQualified };
